import { render, staticRenderFns } from "./GeoJson2Popup.vue?vue&type=template&id=391066ec&scoped=true&"
import script from "./GeoJson2Popup.vue?vue&type=script&lang=js&"
export * from "./GeoJson2Popup.vue?vue&type=script&lang=js&"
import style0 from "./GeoJson2Popup.vue?vue&type=style&index=0&id=391066ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391066ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VFlex,VLayout})
